import React, { useEffect } from 'react';
import '../../styles/common.css';
import styles from './PaymentResult.module.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const PaymentResult = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  useEffect(() => {
    if (!loading && user) navigate('/profile#purchases', { replace: true });
  }, [loading, user, navigate]);
  // Determine success/failed based on pathname
  const isSuccess = location.pathname === '/payment-success';

  return (
    <div className={styles.result}>
      <div className="container">
        <div style={{ marginTop: '1rem' }}>
        <div className={`glassCard ${styles.card}`}>
          <header className={styles.header}>
            <h1 className="title">{isSuccess ? 'Проверяем оплату' : 'Оплата не завершена'}</h1>
            <p className="lead">
              {isSuccess
                ? 'Вы вернулись с платёжной страницы. Откройте «Мои покупки»: там появится подтверждение от платёжной системы и статус начисления токенов.'
                : 'Проверьте статус в «Моих покупках». Если деньги уже списаны, не оплачивайте повторно — дождитесь подтверждения или обратитесь в поддержку.'}
            </p>
          </header>

          <section className={styles.actions}>
            {isSuccess ? (
              <>
                <a href="/profile#purchases" className="btnPrimaryCustom" style={{ marginRight: '0.75rem' }}>
                  Мои покупки
                </a>
                <a href="/contacts" className="btnSecondary">
                  Связаться с поддержкой
                </a>
              </>
            ) : (
              <>
                <a href="/profile#purchases" className="btnPrimaryCustom" style={{ marginRight: '0.75rem' }}>
                  Проверить статус
                </a>
                <a href="/contacts" className="btnSecondary">
                  Связаться с поддержкой
                </a>
              </>
            )}
          </section>

          <section className={styles.details}>
            <h2 className={styles.detailsTitle}>Что делать дальше</h2>
            <p className="lead">
              {isSuccess
                ? 'Если через 15 минут токены не пришли — напишите в поддержку, укажите никнейм и номер платежа.'
                : 'Если деньги списаны, сохраните чек. При задержке более 15 минут обратитесь в поддержку с номером заказа.'}
            </p>
          </section>
        </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentResult;
